import { InMemoryWebStorage } from '@twigeducation/oidc-client-react';

class InMemoryStorage {
    static instance;

    static getInstance() {
        InMemoryStorage.instance = InMemoryStorage.instance ?? new InMemoryWebStorage();

        return InMemoryStorage.instance;
    }
}

const setInMemory = (key, value) => InMemoryStorage.getInstance().setItem(key, value);

const getInMemory = (key) => InMemoryStorage.getInstance().getItem(key);

const removeInMemory = (key) => InMemoryStorage.getInstance().removeItem(key);

const clearInMemory = () => InMemoryStorage.getInstance().clear();

export default InMemoryStorage;
export { setInMemory, getInMemory, removeInMemory, clearInMemory };
